import { render, staticRenderFns } from "./selectChapter.vue?vue&type=template&id=241c4bba&scoped=true&"
import script from "./selectChapter.vue?vue&type=script&lang=js&"
export * from "./selectChapter.vue?vue&type=script&lang=js&"
import style0 from "./selectChapter.vue?vue&type=style&index=0&id=241c4bba&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241c4bba",
  null
  
)

export default component.exports